import { render, staticRenderFns } from "./PageCatalogAboveCatalogProductsRecommendedHook.vue?vue&type=template&id=10ab1040&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports